import "./style.scss";
import "./style-mob.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { AdvantagesSliderConst } from "@/src/constants/advantages";
import advantagesSlideBg from "@/src/assets/HomePage/Advantages/advantages-slide-bg.png";
import univSchoolCardBgMob from "@/src/assets/HomePage/UniversityPrograms/univ-school-card-bg-mob.png";
import { Autoplay } from "swiper/modules";

const AdvantagesSlider = () => {
  return (
    <div className="advantages-slider">
      <Swiper
        modules={[Autoplay]}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1.65,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3.98,
            spaceBetween: 0,
          },
        }}
      >
        {AdvantagesSliderConst.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="advantages-slider-content">
              <div className="advantages-slider-static">
                <div className="advantages-slider-static-bg">
                  <img className="desk" src={advantagesSlideBg} alt="Slider Bg Img" />
                  <img className="mob" src={univSchoolCardBgMob} alt="Slider Bg Img Mob" />
                </div>
                <div className="advantages-slider-static-image">
                  <img src={item.image} alt="Slider Img" />
                </div>
                <div className="advantages-slider-static-title">
                  <p>{item.title}</p>
                </div>
                <div className="advantages-slider-static-point"></div>
              </div>
              <div className="advantages-slider-hover">
                <div className="advantages-slider-hover-title">
                  <p>{item.title}</p>
                </div>
                <div className="advantages-slider-hover-description">
                  <p>{item.description}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default AdvantagesSlider;
